import { Button, Popover, Select, Tooltip } from 'antd';
import { ArrowDownOutlined, ArrowUpOutlined } from '@ant-design/icons';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import style from '../../Overview.module.css';
import { setBizModalEv } from '../../../../models/overviewModel/index.js';
import {
  actualityDictionary,
  infoSourceDictionary,
} from '../../../../dictionaries/info_source_dictionary.js';
import { ChartTableIcon } from '../../../../utils/customIcons.jsx';

export default function OverviewBizCard(props) {
  const {
    title,
    cards,
    cardClick,
    field,
    activeSubCategory,
    granularity,
    changeFilters,
    showInfo,
  } = props;
  const setModal = useUnit(setBizModalEv);
  const { t } = useTranslation();

  return (
    <div
      className={style.overview_card}
      onClick={cardClick}
      data-category={field}
      data-subcategory={cards[0].subCategory}
      data-type="card"
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 8,
        }}
      >
        <div
          className={[
            style.overview_card_title,
            field === 'projectsRealisation' ? style.center : '',
          ].join(' ')}
          style={{ display: 'inline-block', width: '70%' }}
        >
          {title}
        </div>
        <Select
          style={{ width: 210 }}
          size={'small'}
          options={[
            {
              label: t('dashboard.business_climate.Ежеквартально'),
              value: false,
            },
            { label: t('dashboard.business_climate.Годовой'), value: true },
          ]}
          value={granularity}
          onChange={(v) =>
            changeFilters({ field: 'business_climate_yearly', value: v })
          }
        />
      </div>
      {/*<span*/}
      {/*  className={style.overview_subcard_title}*/}
      {/*  style={{ fontSize: 16, marginBottom: -8 }}*/}
      {/*>*/}
      {/*  Эффективность деятельности МИО*/}
      {/*</span>*/}
      <div className={style.cards_wrapper}>
        {cards.map((item) => {
          return (
            <div
              className={[
                style.overview_subcard,
                cards?.length === 1 ? style.card_full_width : '',
                activeSubCategory.length > 0 &&
                activeSubCategory === item.subCategory
                  ? style.overview_subcard_active
                  : '',
              ].join(' ')}
              data-category={field}
              data-subcategory={item.subCategory}
              data-type="subcard"
            >
              <div
                className={`${
                  item.breakWord
                    ? style.title_break
                    : style.overview_subcard_title
                } ${showInfo && 'flex-8'}`}
                style={{ fontSize: 16, fontWeight: 400 }}
              >
                {item.header}
                {/*{showInfo && (*/}
                {/*  <div>*/}
                {/*    <Popover*/}
                {/*      title={*/}
                {/*        <div*/}
                {/*          style={{*/}
                {/*            display: 'flex',*/}
                {/*            flexDirection: 'column',*/}
                {/*            gap: 4,*/}
                {/*          }}*/}
                {/*        >*/}
                {/*          <span>{`Источник данных: ${*/}
                {/*            infoSourceDictionary[item.subCategory]*/}
                {/*          }`}</span>*/}
                {/*          <span>{`Актуализация: ${*/}
                {/*            actualityDictionary[item.subCategory]*/}
                {/*          }`}</span>*/}
                {/*        </div>*/}
                {/*      }*/}
                {/*    >*/}
                {/*      <InfoCircleOutlined style={{ height: 16 }} />*/}
                {/*    </Popover>*/}
                {/*  </div>*/}
                {/*)}*/}
              </div>
              <div className={style.overview_value}>{item.value}</div>
              <div className={style.overview_measure}>{item.measure}</div>
              <div
                className={style.overview_subcard_footer}
                style={{ marginTop: 22 }}
              >
                <div className={style.overview_subcard_footer_v}>
                  <div className={style.overview_subcard_date}>
                    {granularity
                      ? item.date.split(' ').at(-1) ?? ''
                      : item.date ?? ''}
                  </div>
                  <div
                    className={style.overview_subcard_percent}
                    style={{
                      color:
                        item.type === 'neutral'
                          ? 'var(--warning)'
                          : item.type === 'positive'
                          ? 'var(--success)'
                          : 'var(--danger)',
                    }}
                  >
                    {item.percent ?? ''}%
                    {item.type !== 'neutral' ? (
                      item.type === 'positive' ? (
                        <ArrowUpOutlined />
                      ) : (
                        <ArrowDownOutlined />
                      )
                    ) : (
                      ''
                    )}
                  </div>
                </div>
                <div style={{ display: 'flex', alignSelf: 'flex-end' }}>
                  <Tooltip
                    title={t('dashboard.business_climate.Просмотр по районам')}
                    placement="bottom"
                  >
                    <Button
                      className={style.modal_button}
                      icon={ChartTableIcon}
                      onClick={() =>
                        setModal({
                          open: true,
                          type: item.subCategory,
                          granularity: granularity ? 'year' : 'quarter',
                        })
                      }
                    />
                  </Tooltip>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
